import { render, staticRenderFns } from "./PreparationStage.vue?vue&type=template&id=52c1c20f&functional=true&"
var script = {}
import style0 from "./PreparationStage.vue?vue&type=style&index=0&id=52c1c20f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports